import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';

export default function MiniClipPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <div className="bg-gray-100 py-4">
        <div className="container mx-auto px-4 flex items-center gap-2 text-sm">
          <h5 className="font-semibold">MINI CLIP</h5>
          <span>/</span>
          <Link to="/" className="text-gray-600 hover:text-[#c41e3a]">Home</Link>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Left Column - Images and Video */}
          <div>
            <div className="mb-6">
              <img 
                              src="/images/MC6551_Hero.jpg" 
                alt="Mini Clip" 
                className="w-full rounded-lg shadow-lg"
              />
            </div>
            
          </div>

          {/* Right Column - Product Details */}
          <div className="bg-gray-50 p-8 rounded-lg">
            
            
            <h1 className="text-4xl font-bold text-gray-900 mb-4">MINI CLIP</h1>
            <h4 className="text-xl text-gray-700 mb-2">Model: MC7551 (Tractors Without Auxiliary Hydraulics)</h4>
            <h4 className="text-xl text-gray-700 mb-6">Weight: 632 lbs</h4>

            <div className="prose max-w-none text-gray-700">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Finally, A Tree Shear For Smaller Equipment!</h2>
              
              <p className="mb-4">
                Finally, a mini clipper tree shear for compact and utility tractors. It is light weight at 606 lbs. and will only requires 1200 lbs. of lift capacity. We also recommend using a counter weight such as a 3-point attachment or rear wheel weights for added stability. This tree cutter attachment for tractors has a maximum cut radius of 7 inches and features manual telescoping for 6', 7', and 8' reach.
              </p>

              <h4 className="text-lg font-bold text-gray-900 mb-3">The Mini Clip Tree Shear is available in two models.</h4>

              <h4 className="text-lg font-bold text-gray-900 mb-2">MC7551:</h4>
              <p className="mb-4">
                For tractors without existing auxiliary hydraulics. The MC7551 Mini Clip tractor tree cutter includes the MP020 Xtra Valve Kit which will create auxiliary hydraulic outlets. Those outlets can also be used for other attachments such as grapples or blades in addition to the Mini Clip.
              </p>
              <p className="mb-4">
                The valve is controlled with a two button control handle. One button activates the cutting while the other button rotates the head for trimming limbs.
              </p>

              <h4 className="text-lg font-bold text-gray-900 mb-2">MC6551:</h4>
              <p className="mb-4">
                For skid steers and tractors with existing auxiliary hydraulic outlets. The control kit includes a wireless remote to control the rotation.
              </p>

              

              <h2 className="text-2xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>

              <p className="mb-2"><strong>Q: What size trees can the Mini Clip Tree Shear cut?</strong></p>
              <p className="mb-4"><strong>A:</strong> The Mini Clip Tree Shear is designed for smaller to medium-sized trees with a maximum cutting capacity of 7 inches in diameter. This compact tractor tree cutter attachment is perfect for property maintenance, clearing land, and forestry management tasks that don't require industrial-sized equipment.</p>

              <p className="mb-2"><strong>Q: Will the Mini Clip work with my tractor if it doesn't have auxiliary hydraulics?</strong></p>
              <p className="mb-4"><strong>A:</strong> Yes! The MC7551 model is specifically designed for tractors without auxiliary hydraulics. This model includes the MP020 Xtra Valve Kit that creates the necessary hydraulic outlets for operating the tree shear. As an added benefit, these same hydraulic outlets can be used for other attachments like grapples or blades when you're not using the Mini Clip.</p>

              <p className="mb-2"><strong>Q: How much lift capacity does my tractor need to operate the Mini Clip Tree Shear?</strong></p>
              <p className="mb-4"><strong>A:</strong> Your tractor needs a minimum lift capacity of 1200 lbs to safely operate the Mini Clip tree shear. The attachment itself weighs 632 lbs (or 606 lbs depending on the model). For optimal stability and performance, we recommend using a counterweight such as a 3-point attachment or rear wheel weights. This ensures your tractor remains balanced when operating the tree cutter attachment, especially when fully extended to its maximum 8′ reach.</p>
            </div>

            <hr className="my-6 border-gray-300" />

            {/* Features Accordion */}
            <div className="mb-6">
              <details className="group" open>
                <summary className="flex justify-between items-center cursor-pointer list-none p-4 bg-white rounded-lg shadow-sm hover:bg-gray-50">
                  <span className="font-bold text-gray-900">FEATURES</span>
                  <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="p-4 bg-white mt-2 rounded-lg shadow-sm">
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Plumbed</li>
                    <li>Manual Telescoping for 6', 7' and 8' Reach</li>
                    <li>7" Maximum Cut</li>
                    <li>Universal Quick Attach Bracket</li>
                    <li>Minimum 1200 lb. lift capacity</li>
                    <li>2500 PSI Hydraulic Pressure Required</li>
                    <li>Optional Sprayer</li>
                    <li>Hand Control Kits Available</li>
                  </ul>
                </div>
              </details>
            </div>

            {/* Call to Action Buttons */}
            <div className="flex flex-col gap-4">
              <a 
                href="/contact" 
                className="bg-[#c41e3a] text-white text-center py-3 px-6 rounded-lg font-semibold hover:bg-[#a01830] transition-colors"
              >
                Call Us Now
              </a>
              <div className="flex gap-4">
                
              </div>
            </div>
          </div>
        </div>
      </div>

      

      {/* Disclaimer */}
      <div className="bg-white py-12">
        <div className="container mx-auto px-4 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">SOLVING TREE & BRUSH PROBLEMS SINCE 1992!</h3>
          <p className="text-gray-700 max-w-3xl mx-auto">
            All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
          </p>
        </div>
      </div>

      
    </div>
  );
}
